import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import Plan from 'components/Plan'
import AlertDialog from 'components/AlertDialog'
import MainButton from 'components/Buttons/MainButton'

import {
  SubContainer,
  HorizontalLine,
  Form,
  Info,
  TextRow,
  Label,
  SubTitle,
  InfoText,
  MoneyText,
  ErrorContainer,
} from '../styles'

export default function Confirmation ({
  subscriptionData = {}
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const [submitting, setSubmitting] = useState (false)
  const [showOkDialog, setShowOkDialog] = useState (false)
  const [paymentUrl, setPaymentUrl] = useState (null)
  const company = AuthService.getUser ()
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleSubmit = async () => {
    setSubmitting (true)
    setErrorMessage (null)
    
    try {

      const { data } = await cutileiApi.post (
        `/companies/${company.id}/subscriptions`, subscriptionData, requestConfig
      )

      // Na Asaas o boleto já vem na resposta; na Vindi ele só chega pelo e-mail
      setPaymentUrl (data?.subscription?.payment_url ?? null)
      setSubmitting (false)
      toggleOkDialog ()
    } catch (error) {
      setSubmitting (false)
      logApiError (error)
      setErrorMessage (getApiErrorMessage (error))
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <SubContainer>
      <SubTitle>Confirme seus dados</SubTitle>
      <InfoText style={{width: 450}}>
        {'Ao confirmar sua assinatura, você receberá uma mensagem em seu endereço de e-mail '
        + 'cadastrado contendo o boleto referente ao pagamento.'}
      </InfoText>
      <InfoText style={{width: 450}}>
        {'Realize o pagamento para que sua assinatura seja ativada e seus colaboradores '
        + 'possam se cadastrar utilizando o seu código promocional para obterem o desconto.'}
      </InfoText>
      <Plan
        data={subscriptionData.plan}
        discount={subscriptionData.discount}
        style={{cursor: 'default'}}
      />
      <Form style={{width: 420}}>
        <SubTitle>Dados da assinatura</SubTitle>
        <Info>
          <TextRow>
            <Label>Número de colaboradores:</Label>
            <InfoText>{subscriptionData.num_users}</InfoText>
          </TextRow>
          <TextRow>
            <Label>Cupom promocional:</Label>
            <InfoText>{subscriptionData.promo_code}</InfoText>
          </TextRow>
          <HorizontalLine/>
          <SubTitle>
            Valor total:&ensp;
            <MoneyText value={subscriptionData.num_users * subscriptionData.discount}/>
          </SubTitle>
        </Info>
      </Form>
      {errorMessage && (
        <ErrorContainer>
          <p>{errorMessage}</p>
        </ErrorContainer>
      )}
      <MainButton
        type='button'
        label='Confirmar assinatura'
        onClick={handleSubmit}
        disabled={submitting}
        loading={submitting}
        width={200}
      />
      <AlertDialog
        visible={showOkDialog}
        title='Assinatura realizada com sucesso!'
        message={
          <>
            <InfoText>
              O boleto da primeira mensalidade chega no e-mail cadastrado. Assim que ele for
              pago, o código promocional passa a valer para os seus colaboradores.
            </InfoText>
            {paymentUrl && (
              <InfoText>
                <a href={paymentUrl} target='_blank' rel='noopener noreferrer'>Abrir o boleto agora</a>
              </InfoText>
            )}
          </>
        }
        confirmText='Ok'
        onConfirm={() => navigate ('/company', { replace: true })}
        onClose={() => navigate ('/company', { replace: true })}
      />
    </SubContainer>
  )
}
